import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex-grow pt-5" }
const _hoisted_2 = { class: "flex flex-col mb-3" }
const _hoisted_3 = {
  key: 0,
  class: "text-next-orange font-bold text-sm"
}
const _hoisted_4 = { class: "flex flex-col mb-3" }
const _hoisted_5 = {
  key: 0,
  class: "text-next-orange font-bold text-sm"
}
const _hoisted_6 = { class: "flex flex-col mb-3" }
const _hoisted_7 = {
  key: 0,
  class: "text-next-orange font-bold text-sm"
}
const _hoisted_8 = { class: "flex justify-end pt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    visible: _ctx.visible,
    "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.visible) = $event))
  }, {
    header: _withCtx(() => _cache[5] || (_cache[5] = [
      _createElementVNode("div", null, [
        _createElementVNode("h2", { class: "text-lg font-bold" }, "Nuovo figlio")
      ], -1)
    ])),
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[6] || (_cache[6] = _createElementVNode("div", null, "Nome", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.nome) = $event)),
            placeholder: "Nome",
            class: "col-span-3 p-2 bg-next-gray-md"
          }, null, 512), [
            [_vModelText, _ctx.nome]
          ]),
          (_ctx.figlio_modal_error.nome)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.figlio_modal_error.nome), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[8] || (_cache[8] = _createElementVNode("div", null, "Sesso", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.sesso) = $event)),
            class: "col-span-3 p-2 bg-next-gray-md"
          }, _cache[7] || (_cache[7] = [
            _createElementVNode("option", { value: "M" }, "Maschio", -1),
            _createElementVNode("option", { value: "F" }, "Femmina", -1)
          ]), 512), [
            [_vModelSelect, _ctx.sesso]
          ]),
          (_ctx.figlio_modal_error.sesso)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.figlio_modal_error.sesso), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[9] || (_cache[9] = _createElementVNode("div", null, "Anno nascita", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.eta) = $event)),
            placeholder: "Età",
            type: "number",
            min: "0",
            max: "255",
            class: "col-span-3 p-2 bg-next-gray-md"
          }, null, 512), [
            [_vModelText, _ctx.eta]
          ]),
          (_ctx.figlio_modal_error.eta)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.figlio_modal_error.eta), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_NextButton, {
          variant: "outline-secondary",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:visible', false))),
          class: "col-start-3 py-2 px-4"
        }, {
          default: _withCtx(() => _cache[10] || (_cache[10] = [
            _createTextVNode(" Chiudi ")
          ])),
          _: 1
        }),
        _createVNode(_component_NextButton, {
          variant: "primary",
          onClick: _ctx.addFiglio,
          class: "ml-4 py-2 px-4"
        }, {
          default: _withCtx(() => _cache[11] || (_cache[11] = [
            _createTextVNode(" Aggiungi ")
          ])),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}